import { render } from "./SectionTechItem.vue?vue&type=template&id=6ff2c77f&scoped=true"
import script from "./SectionTechItem.vue?vue&type=script&lang=js"
export * from "./SectionTechItem.vue?vue&type=script&lang=js"

import "./SectionTechItem.vue?vue&type=style&index=0&id=6ff2c77f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff2c77f"]])

export default __exports__